import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoCircleFilled } from "@ant-design/icons";
import { Typography, theme } from "antd";
import { observer } from "mobx-react";
import { __, _i } from "../../../../../../utils/i18n.js";
import { InfoCard } from "../../../infoCard.js";
import { KeyBenefit } from "../../../keyBenefit.js";
const { Title } = Typography;
const AffiliateSignupSidebar = observer(()=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-affiliate-signup__sidebar",
        children: [
            /*#__PURE__*/ _jsx(Title, {
                level: 4,
                style: {
                    marginBottom: 4
                },
                children: __("Earn commissions for every recommendation")
            }),
            /*#__PURE__*/ _jsx("p", {
                style: {
                    color: token.colorTextSecondary
                },
                children: __("Recommend our products to your customers, readers, and audience.")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-affiliate-benefits",
                children: [
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        heading: /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-affiliate-benefit",
                            children: _i(__("{{strong}}25 %{{/strong}} commission on every referred sale"), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        heading: /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-affiliate-benefit",
                            children: _i(__("{{strong}}14-day{{/strong}} attribution window"), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        heading: /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-affiliate-benefit",
                            children: _i(__("{{strong}}Cookie-less{{/strong}} link tracking with GET parameter forwarding"), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        heading: /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-affiliate-benefit",
                            children: _i(__("{{strong}}Branded{{/strong}} coupons for exclusive discounts"), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(KeyBenefit, {
                        heading: /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-affiliate-benefit",
                            children: _i(__("{{strong}}No{{/strong}} SEPA payout fees, paid monthly"), {
                                strong: /*#__PURE__*/ _jsx("strong", {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: 16
                },
                children: /*#__PURE__*/ _jsx(InfoCard, {
                    variant: "bordered-info",
                    icon: /*#__PURE__*/ _jsx(InfoCircleFilled, {
                        style: {
                            color: token.colorPrimary
                        }
                    }),
                    children: __("Open to companies/organizations only. You'll need valid proof - a VAT ID, a commercial register excerpt, or a trade license.")
                })
            })
        ]
    });
});
export { AffiliateSignupSidebar };
